<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th width="25%">Info</th>
              <th>Active</th>
              <th v-html="priceHeader"></th>
              <th><Tooltip label="Minimum price per individual item. This amount is not multiplied by sales rates" helpStyle>Min Price Per Item</Tooltip></th>
              <th><Tooltip label="Minimum price per group. This amount is not multiplied by sales rates" helpStyle>Min Price Per Group</Tooltip></th>
              <th>Actions</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="(price, index) in stockPriceList" :key="index">
              <td class="font-weight-bold">
                {{price.name}}
                <span v-if="price.isPendingUpdate" class="pricing-pending-update">
                  <Tooltip label="Price updates pending"><i class="far fa-clock"></i></Tooltip>
                </span>
              </td>
              <td>
                <FormCheckbox :value="price.isActive" @change="price.isActive = $event; priceUpdated()" v-show="editing && !price.isPendingUpdate" />
                <span v-show="!editing || price.isPendingUpdate" v-html="dataDisplayTableBoolean(price.isActive, {showFalse:true})"></span>
              </td>
              <td>
                <FormInputStockPrice :uomType="uomType" :value="price.price" @input="price.price = $event; priceUpdated()" v-show="editing && !price.isPendingUpdate" />
                <span v-show="!editing || price.isPendingUpdate">{{price.price | formatPriceWithUOM(uomType)}}</span>
                <span v-show="editing && price.isPendingUpdate" class="form-field-note">Price update pending, cannot update</span>
              </td>
              <td>
                <FormInputCurrency :value="price.minChargeItemPrice" @input="price.minChargeItemPrice = $event; priceUpdated()" v-show="editing && !price.isPendingUpdate" />
                <span v-show="!editing || price.isPendingUpdate">{{price.minChargeItemPrice | formatCurrency(2, true)}}</span>
                <span v-show="editing && price.isPendingUpdate" class="form-field-note">Price update pending, cannot update</span>
              </td>
              <td>
                <FormInputCurrency :value="price.minChargePrice" @input="price.minChargePrice = $event; priceUpdated()" v-show="editing && !price.isPendingUpdate" />
                <span v-show="!editing || price.isPendingUpdate">{{price.minChargePrice | formatCurrency(2, true)}}</span>
                <span v-show="editing && price.isPendingUpdate" class="form-field-note">Price update pending, cannot update</span>
              </td>
              <td>
                <ActionDropMenu :tableAction="true" :forceDropdown="true" v-if="!editing && price.isPendingUpdate && userHasReadPermission(PermissionTypes.PricingPermissionTypes.pricingApproval)">
                  <DropdownMenuItem :link="`/pricing/requests/${price.stockPriceRequestGroupId}`" icon="fa-clock" label="Show Pending Prices">Show Pending Prices</DropdownMenuItem>
                </ActionDropMenu>
              </td>
            </tr>
          </template>
        </StaticDataTable>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="btn-group float-right">
          <button class="btn btn-xs btn-white" :class="[isSalesMatrixDisplayPrice ? 'active' : '']" @click.prevent="isSalesMatrixDisplayPrice=true">Price</button>
          <button class="btn btn-xs btn-white" :class="[!isSalesMatrixDisplayPrice ? 'active' : '']" @click.prevent="isSalesMatrixDisplayPrice=false">Diff</button>
        </div>
        <h3>Sales Matrix</h3>
      </div>
    </div>

    <StockPricingMatrix
      :priceCategoryList="stockPriceList"
      :displayPrice="isSalesMatrixDisplayPrice"
      :uomType="uomType"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import * as Types from '@/store/types'
import Utils from '@/utils/utils'
import DataDisplayMixin from '@/mixins/dataDisplay'
import StaticDataTable from "@/components/table/staticDataTable.vue"
import StockPricingMatrix from '@/modules/pricing/components/stockPricingMatrix.vue'
import FormInputStockPrice from '@/modules/pricing/components/formInputStockPrice'


export default {
  name: "SalesAssemblyPricingEditor",
  mixins: [DataDisplayMixin],
  components: {
    StaticDataTable,
    StockPricingMatrix,
    FormInputStockPrice
  },
  props: {
    priceList: Array,
    uomType: String,
    editing: Boolean
  },
  watch: {
    priceList: function(newVal) { 
      this.$data.stockPriceList = _.cloneDeep(newVal)
    }
  },
  computed: {
    priceHeader() {
      if(this.uomType == Types.UOMTypes.percentOfLineItem || this.uomType == Types.UOMTypes.percentOfOrder)
        return Utils.getLookupName(Types.UOMTypeLookup, this.uomType)

      let uomDisplay = Utils.getLookupName(Types.UOMTypeUnitsLookup, this.uomType)
      return `Price / ${uomDisplay}`
    }
  },
  methods: {
    priceUpdated() {
      this.$emit('update', this.$data.stockPriceList)
    }
  },
  data() {
    return {
      isSalesMatrixDisplayPrice: true,
      stockPriceList: _.cloneDeep(this.$props.priceList)
    }
  },  
}
</script>